import React from "react";
import DashboardSectionEmptyState from "./DashboardSectionEmptyState";
import performanceEmptyIcon from "../../../utilities/images/study_dashboard/empty_states/performance_overview.svg";
import { getAccuracyTone } from "../utils/dashboardBottomUtils";
import "./PerformanceOverview.css";

const SKELETON_ROW_COUNT = 3;

const PerformanceOverviewSkeleton = () => (
  <div className="performance-overview__list" aria-hidden="true">
    {Array.from({ length: SKELETON_ROW_COUNT }, (_, index) => (
      <article
        key={index}
        className="performance-overview__item performance-overview__item--skeleton"
      >
        <div className="performance-overview__meta">
          <span className="performance-overview__skeleton performance-overview__skeleton--name" />
          <span className="performance-overview__skeleton performance-overview__skeleton--accuracy" />
        </div>
        <span className="performance-overview__skeleton performance-overview__skeleton--bar" />
      </article>
    ))}
  </div>
);

const PerformanceOverview = ({ subjects = [], isLoading = false }) => {
  const showEmpty = !isLoading && !subjects.length;

  return (
    <section
      className={`performance-overview${showEmpty ? " performance-overview--empty" : ""}`}
      aria-labelledby="performance-overview-title"
      aria-busy={isLoading || undefined}
    >
      <h2 id="performance-overview-title" className="performance-overview__title">
        Performance Overview
      </h2>

      {isLoading ? (
        <PerformanceOverviewSkeleton />
      ) : showEmpty ? (
        <DashboardSectionEmptyState
          icon={performanceEmptyIcon}
          title="No Performance Data Yet"
          description="Your subject-wise performance will be displayed here based on your test performance."
        />
      ) : (
        <div className="performance-overview__list">
          {subjects.map((subject) => {
            const accuracyValue = subject.accuracy;
            const accuracy =
              accuracyValue == null
                ? null
                : Math.min(100, Math.max(0, Number(accuracyValue) || 0));
            const tone = getAccuracyTone(accuracy);

            return (
              <article key={subject.id} className="performance-overview__item">
                <div className="performance-overview__meta">
                  <span className="performance-overview__name">{subject.name}</span>
                  <span
                    className={`performance-overview__accuracy performance-overview__accuracy--${tone}`}
                  >
                    {accuracyValue != null ? `${accuracyValue}%` : "—"} accuracy
                  </span>
                </div>
                <div className="performance-overview__track" aria-hidden="true">
                  <span
                    className={`performance-overview__fill performance-overview__fill--${tone}`}
                    style={{ width: `${accuracy ?? 0}%` }}
                  />
                </div>
              </article>
            );
          })}
        </div>
      )}
    </section>
  );
};

export default PerformanceOverview;
